// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-agent-wrapper {
    height: 85vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ai-agent-wrapper .input-wrapper {
    display: flex;
    align-items: center;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 22px;
    padding: 12px 22px;
    width: 80%;
}

.ai-agent-wrapper .input-wrapper input {
    padding-right: 10px;
    border-radius: 0;
    border: 0;
    color: gray;
    width: 100%;
}

.voice-icon {
    color: #A261F5;
    font-size: 25px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/ai-agents/ai-agents/ai-agents.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB","sourcesContent":[".ai-agent-wrapper {\n    height: 85vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.ai-agent-wrapper .input-wrapper {\n    display: flex;\n    align-items: center;\n    background-color: white;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 22px;\n    padding: 12px 22px;\n    width: 80%;\n}\n\n.ai-agent-wrapper .input-wrapper input {\n    padding-right: 10px;\n    border-radius: 0;\n    border: 0;\n    color: gray;\n    width: 100%;\n}\n\n.voice-icon {\n    color: #A261F5;\n    font-size: 25px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
